<div class="range-control" (mouseover)="over()" (mouseout)="out()">
  <h4 style="line-height: 1.5">{{ sliderdata.caption }}</h4>
  <input
    type="range"
    [min]="min"
    max="10"
    value="{{ sliderdata.value }}"
    class="mb-4"
    #ranger
    (change)="doSomething(ranger.value)"
    [ngStyle]="{ background: getStyle() }"
    [disabled]="readonly"
  />
  <div style="width: 80%; position: absolute; top: 0" [hidden]="!ishover">
    <output [ngStyle]="{ color: rgbColor }">{{ sliderdata.value }}</output>
  </div>
</div>
